import { render, staticRenderFns } from "./documentos-snii.vue?vue&type=template&id=8bd173b2&scoped=true&"
import script from "./documentos-snii.component.ts?vue&type=script&lang=ts&"
export * from "./documentos-snii.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd173b2",
  null
  
)

export default component.exports